import { render } from "./taote_goods.vue?vue&type=template&id=e1d85fae&scoped=true"
import script from "./taote_goods.vue?vue&type=script&lang=js"
export * from "./taote_goods.vue?vue&type=script&lang=js"

import "./taote_goods.vue?vue&type=style&index=0&id=e1d85fae&scoped=true&lang=less"

import exportComponent from "C:\\code\\zfb_xf_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d85fae"]])

export default __exports__